import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { status, role, login } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  // Si déjà authentifié comme admin, redirige vers dashboard
  useEffect(() => {
    if (status === 'authenticated' && role === 'admin') {
      navigate('/admin/dashboard');
    }
  }, [status, role, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password, 'admin');
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Erreur de connexion');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#F5F3F0',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: '#FDFCFA', borderRadius: 20, padding: '48px 40px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)', width: '100%', maxWidth: 400,
        border: '1px solid #D9D9D9',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14, margin: '0 auto 16px',
            background: 'linear-gradient(135deg, #D4724A, #F0B89A)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, color: '#fff', fontWeight: 700,
          }}>A</div>
          <h1 style={{ fontFamily: 'Lora, serif', fontSize: 26, fontWeight: 700, color: '#D4724A', margin: '0 0 4px' }}>
            Aidly Admin
          </h1>
          <p style={{ fontSize: 14, color: '#8A8A8A', margin: 0 }}>Accès réservé à l'équipe Aidly</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#5A5A5A', marginBottom: 8 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="vous@aidly.fr"
              required
              autoFocus
              autoComplete="email"
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 10,
                border: error ? '2px solid #C0392B' : '2px solid #D9D9D9',
                background: error ? '#FDECEA' : '#FDFCFA',
                fontSize: 16, outline: 'none', boxSizing: 'border-box',
                transition: '0.2s ease',
              }}
              onFocus={e => { e.target.style.borderColor = '#D4724A'; e.target.style.boxShadow = '0 0 0 3px rgba(212,114,74,0.15)'; }}
              onBlur={e => { e.target.style.borderColor = error ? '#C0392B' : '#D9D9D9'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#5A5A5A', marginBottom: 8 }}>
              Mot de passe administrateur
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••••••"
              required
              autoComplete="current-password"
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 10,
                border: error ? '2px solid #C0392B' : '2px solid #D9D9D9',
                background: error ? '#FDECEA' : '#FDFCFA',
                fontSize: 16, outline: 'none', boxSizing: 'border-box',
                transition: '0.2s ease',
              }}
              onFocus={e => { e.target.style.borderColor = '#D4724A'; e.target.style.boxShadow = '0 0 0 3px rgba(212,114,74,0.15)'; }}
              onBlur={e => { e.target.style.borderColor = error ? '#C0392B' : '#D9D9D9'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          {error && (
            <div style={{
              background: '#FDECEA', border: '1px solid rgba(192,57,43,0.3)',
              borderRadius: 8, padding: '10px 14px', marginBottom: 16,
              fontSize: 14, color: '#C0392B',
            }}>{error}</div>
          )}

          <button
            type="submit"
            disabled={loading || !email || !password}
            style={{
              width: '100%', padding: '14px', borderRadius: 12, border: 'none',
              background: loading || !email || !password ? '#D9D9D9' : '#D4724A',
              color: loading || !email || !password ? '#8A8A8A' : '#fff',
              fontSize: 16, fontWeight: 600, cursor: loading || !email || !password ? 'not-allowed' : 'pointer',
              transition: '0.2s ease', letterSpacing: '0.02em',
            }}
          >
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#8A8A8A' }}>
          Session valide 8 heures • Données sécurisées JWT
        </p>
      </div>
    </div>
  );
}
